module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-4.0ed59320.svg";